import {NgModule} from '@angular/core';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule, MatIconRegistry} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatMomentDatetimeModule} from '@mat-datetimepicker/moment';
import {MatDatetimepickerModule} from '@mat-datetimepicker/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule} from '@angular/material-moment-adapter';

@NgModule({
  imports: [
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatMomentDatetimeModule,
    MatDatetimepickerModule,
    MatMomentDateModule,
  ],
  providers:[
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: false}},
    { provide: MAT_DIALOG_DATA, useValue: {} },
  ],
  exports: [
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatAutocompleteModule,
    MatMomentDatetimeModule,
    MatDatetimepickerModule,
    MatMomentDateModule
  ]
})
export class MaterialModule {
  constructor(private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer) {
    this.initIcons();
  }

  private initIcons() {
    this.matIconRegistry.addSvgIcon('arrow-down-sign-to-navigate', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/arrow-down-sign-to-navigate.svg'));
    this.matIconRegistry.addSvgIcon('assignment', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/assignment.svg'));
    this.matIconRegistry.addSvgIcon('client', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/client.svg'));
    this.matIconRegistry.addSvgIcon('dots', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/dots.svg'));
    this.matIconRegistry.addSvgIcon('columns', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/columns.svg'));
    this.matIconRegistry.addSvgIcon('email', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/email.svg'));
    this.matIconRegistry.addSvgIcon('filter', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/filter.svg'));
    this.matIconRegistry.addSvgIcon('graph', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/graph.svg'));
    this.matIconRegistry.addSvgIcon('left-arrow', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/left-arrow.svg'));
    this.matIconRegistry.addSvgIcon('left', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/left.svg'));
    this.matIconRegistry.addSvgIcon('magnifying-glass', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/magnifying-glass.svg'));
    this.matIconRegistry.addSvgIcon('menu', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/menu.svg'));
    this.matIconRegistry.addSvgIcon('notification', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/notification.svg'));
    this.matIconRegistry.addSvgIcon('plus', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/plus.svg'));
    this.matIconRegistry.addSvgIcon('refresh', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/refresh.svg'));
    this.matIconRegistry.addSvgIcon('setting-1', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/setting-1.svg'));
    this.matIconRegistry.addSvgIcon('settings', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/settings.svg'));
    this.matIconRegistry.addSvgIcon('writing', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/writing.svg'));
    this.matIconRegistry.addSvgIcon('email-2', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/email-2.svg'));
    this.matIconRegistry.addSvgIcon('password', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/password.svg'));
    this.matIconRegistry.addSvgIcon('google', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/google.svg'));
    this.matIconRegistry.addSvgIcon('barcode-scan', this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/svg/barcode-scan.svg'));
  }
}
